import { RELATION_REQUIRED_CODE, type RelationRequiredPayload } from '~/types/patient'

export function relationRequiredFromFetch(error: unknown): RelationRequiredPayload | null {
  const root = (error as { data?: unknown })?.data
  if (!root || typeof root !== 'object') return null
  const nested = (root as { data?: unknown }).data
  const candidates = [nested, root]
  for (const candidate of candidates) {
    if (
      candidate
      && typeof candidate === 'object'
      && (candidate as RelationRequiredPayload).code === RELATION_REQUIRED_CODE
      && Array.isArray((candidate as RelationRequiredPayload).members)
    ) {
      return candidate as RelationRequiredPayload
    }
  }
  return null
}
